export const LOCKED_NOTIFICATION_PREFERENCES = [
  "notification_email_messages",
  "notification_email_booking_updates",
  "notification_email_rental_reminder",
  "notification_email_rate_experience",
] as const;

export type LockedNotificationPreference = typeof LOCKED_NOTIFICATION_PREFERENCES[number];

export function isLockedNotificationPreference(key: string): key is LockedNotificationPreference {
  return (LOCKED_NOTIFICATION_PREFERENCES as readonly string[]).includes(key);
}

export function applyLockedNotificationPolicy<T extends Record<string, unknown>>(record: T): T {
  const out: Record<string, unknown> = { ...record };
  for (const key of LOCKED_NOTIFICATION_PREFERENCES) {
    if (Object.hasOwn(out, key)) {
      out[key] = true;
    }
  }
  return out as T;
}
